var _excluded = ["title", "parameters", "label", "price", "renewPrice", "additionalInfo", "button", "buttonColor", "buttonVariant"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import React, { useContext } from "react";
import styled, { css } from "styled-components";
import OnColorContext from "../../../contexts/OnColorContext";
var Tick1 = function Tick1(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M15.408 5.349a1.942 1.942 0 0 0 .591-1.387 1.919 1.919 0 0 0-.591-1.387A2.061 2.061 0 0 0 13.978 2a2.06 2.06 0 0 0-1.43.575L5.887 9.037l-2.435-2.36a2.057 2.057 0 0 0-1.43-.576c-.534 0-1.047.207-1.429.575A1.94 1.94 0 0 0 0 8.066a1.916 1.916 0 0 0 .594 1.388l4.253 4.129a1.5 1.5 0 0 0 2.078 0l8.48-8.232"
  }));
};
Tick1.defaultProps = {
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
import getBorderColor from "../../../utils/getBorderColor";
import getBorderRadius from "../../../utils/getBorderRadius";
import getBoxShadow from "../../../utils/getBoxShadow";
import getColor from "../../../utils/getColor";
import space from "../../../utils/space";
import unit from "../../../utils/unit";
import ButtonAtm from "../../atoms/ButtonAtm";
import IconAtm from "../../atoms/IconAtm";
import LabelAtm from "../../atoms/LabelAtm";
import TextAtm from "../../atoms/TextAtm";
import PushOrg from "../../organisms/PushOrg";
export var defaultProps = {
  buttonColor: "secondary",
  buttonVariant: "transparent"
};
var background = "backgroundLight";
var Box = styled.div.withConfig({
  componentId: "sc-1cel2ki-0"
})(function (_ref) {
  var $onColor = _ref.$onColor,
    theme = _ref.theme;
  return css(["display:flex;flex-direction:column;padding:", " ", " ", ";border:", " solid ", ";border-radius:", ";background:", ";box-shadow:", ";"], space(4), space(3), space(3), unit(1), getBorderColor(theme, $onColor, "low"), getBorderRadius(theme, "small"), getColor(theme, background), getBoxShadow(theme, "large"));
});
var Parameters = styled.ul.withConfig({
  componentId: "sc-1cel2ki-1"
})(["margin-bottom:", ";> li{display:flex;align-items:center;justify-content:space-between;margin-bottom:", ";&:last-child{margin-bottom:0;}}"], space(4.5), space(2));
var Footer = styled.div.withConfig({
  componentId: "sc-1cel2ki-2"
})(["margin-top:auto;"]);
var Label = styled(LabelAtm).withConfig({
  componentId: "sc-1cel2ki-3"
})(["margin-bottom:", ";"], space(1));
var Price = styled.div.withConfig({
  componentId: "sc-1cel2ki-4"
})(["display:flex;align-items:baseline;justify-content:space-between;"]);
var PriceValue = styled(TextAtm).withConfig({
  componentId: "sc-1cel2ki-5"
})(["white-space:nowrap;"]);
var PriceSuffix = styled(TextAtm).withConfig({
  componentId: "sc-1cel2ki-6"
})(["text-align:right;"]);
function PackageBoxSimpleMol(_ref2) {
  var title = _ref2.title,
    parameters = _ref2.parameters,
    label = _ref2.label,
    price = _ref2.price,
    renewPrice = _ref2.renewPrice,
    additionalInfo = _ref2.additionalInfo,
    button = _ref2.button,
    _ref2$buttonColor = _ref2.buttonColor,
    buttonColor = _ref2$buttonColor === void 0 ? defaultProps.buttonColor : _ref2$buttonColor,
    _ref2$buttonVariant = _ref2.buttonVariant,
    buttonVariant = _ref2$buttonVariant === void 0 ? defaultProps.buttonVariant : _ref2$buttonVariant,
    restProps = _objectWithoutProperties(_ref2, _excluded);
  var onColor = useContext(OnColorContext);
  return /*#__PURE__*/React.createElement(Box, _extends({
    $onColor: onColor
  }, restProps), /*#__PURE__*/React.createElement(OnColorContext.Provider, {
    value: background
  }, /*#__PURE__*/React.createElement(TextAtm, {
    typography: "large3",
    pushSpace: 4
  }, title), /*#__PURE__*/React.createElement(Parameters, null, parameters.map(function (parameter) {
    return /*#__PURE__*/React.createElement("li", {
      key: parameter.name
    }, /*#__PURE__*/React.createElement(TextAtm, {
      typography: "xsmall1"
    }, parameter.name), parameter.value === true ? /*#__PURE__*/React.createElement(IconAtm, {
      icon: Tick1,
      sizeSpace: 2,
      color: "success"
    }) : /*#__PURE__*/React.createElement(TextAtm, {
      typography: "xsmall3"
    }, parameter.value));
  })), /*#__PURE__*/React.createElement(Footer, null, !!label && /*#__PURE__*/React.createElement(Label, {
    variant: "notify",
    size: "small"
  }, label), /*#__PURE__*/React.createElement(Price, null, /*#__PURE__*/React.createElement(PriceValue, {
    typography: "sgiant"
  }, price.prefix ? /*#__PURE__*/React.createElement(TextAtm, {
    typography: "large2"
  }, "".concat(price.prefix, " ")) : null, price.value, /*#__PURE__*/React.createElement(TextAtm, {
    typography: "large2"
  }, " ".concat(price.currency))), /*#__PURE__*/React.createElement(PriceSuffix, {
    typography: "tiny3"
  }, price.suffix)), !!renewPrice && /*#__PURE__*/React.createElement(TextAtm, {
    typography: "tiny1",
    emphasis: "medium"
  }, renewPrice.label, ": ", /*#__PURE__*/React.createElement("strong", null, renewPrice.value), " ", renewPrice.suffix), !!additionalInfo && /*#__PURE__*/React.createElement(PushOrg, {
    topSpace: 1
  }, /*#__PURE__*/React.createElement(TextAtm, {
    typography: "tiny1",
    emphasis: "medium"
  }, additionalInfo)), /*#__PURE__*/React.createElement(PushOrg, {
    topSpace: 3
  }, /*#__PURE__*/React.createElement(ButtonAtm, {
    to: button.to,
    href: button.href,
    openInNewTab: button.openInNewTab,
    title: button.title,
    onClick: button.onClick,
    rel: button.rel,
    color: buttonColor,
    variant: buttonVariant,
    isExpanded: true
  }, button.text)))));
}
export default PackageBoxSimpleMol;